import { IonFooter, IonImg } from '@ionic/react'
import React from 'react'
import './footer.scss'
import logo_negativo from 'theme/images/logo_negativo.svg'
import { Link } from 'react-router-dom'
import { routeService } from 'services'
import { useTranslation } from 'react-i18next'
import { AppInfo } from 'components/app-info'

const Footer: React.FC = () => {
  const { t } = useTranslation()

  return (
    <IonFooter className="edisu-footer">
      <div className="logo-cnt">
        <IonImg src={logo_negativo} className="footer-logo" />
      </div>
      <div className="text-cnt">
        <span className="edisu-text">{t('edisu_piemonte_desc1')}</span>
        <span className="edisu-text">{t('edisu_piemonte_desc2')}</span>
        <span className="edisu-text">{t('edisu_piemonte_desc3')}</span>
        <span className="edisu-text">{t('edisu_piemonte_desc4')}</span>
        <AppInfo></AppInfo>
      </div>

      <div className="links-cnt">
        <Link to={routeService.generateRoutePath('/about')} className="edisu-footer-link">
          {t('about_us')}
        </Link>
        {/* <Link to={routeService.generateRoutePath('/faq')} className="edisu-footer-link">
          {t('faq')}
        </Link> */}
      </div>
    </IonFooter>
  )
}

export default Footer
